document.addEventListener('rebuy:cart.add', (evt) => {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  const config = {
    method: 'GET',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
    },
  };
  document.addEventListener('rebuy:cart.change', (event) => {
    const changeTitle = () => {
      const rebuyTitles = document.querySelectorAll('cart-drawer #rebuy-widget-160953 .rebuy-product-title-link');
      rebuyTitles?.forEach(el => {
          const titleName = el.textContent;
          if(titleName.includes(' - ')){
              const splitName = titleName.split(' - ')[0];
              if(splitName && splitName.length > 0){
                  el.textContent = splitName;
              }
          }
      })
    }
    changeTitle();
    const intervalId = setInterval(changeTitle, 10);
    setTimeout(() => {
      clearInterval(intervalId);
    }, 3000);
  });


  fetch(window.Shopify.routes.root + '?section_id=cart-drawer', config)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const cartDrawerContent = html.querySelector('.cart-main-items-container').innerHTML;

      cartDrawer.classList.remove('is-empty');
      const drawerInner = cartDrawer.querySelector('.drawer__inner');
      if (drawerInner && drawerInner.classList.contains('is-empty')) {
        drawerInner.classList.remove('is-empty');
      }

      document.querySelector('.cart-main-items-container').innerHTML = cartDrawerContent;

      const overlay = document.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.addEventListener('click', () => cartDrawer.close());
      }

      console.log("REBUY -> ", window.Rebuy);

      cartDrawer.setHeading(true);
      cartDrawer.open();
      cartDrawer.updateCartState();
    })
    .catch((error) => {
      console.error('Error updating cart drawer:', error);
    });
});

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  connectedCallback() {
    this.updateCartState();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.setHeading(false);
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.setHeading(false);
        this.open(cartLink);
      }
    });
  }

  // The drawer is one shared panel: "Added to shopping bag" is only true right after an
  // add-to-cart. Opening it from the header icon (possibly on an empty cart) shows the
  // neutral title instead. Both strings come from the h2's data attributes.
  setHeading(added) {
    const heading = this.querySelector('.drawer__heading');
    if (!heading) return;
    const text = added ? heading.dataset.titleAdded : heading.dataset.titleDefault;
    if (text) heading.textContent = text;
  }

  open(triggeredBy) {
    document.querySelector('.js-offcanvas-trigger.menu-opened')?.dispatchEvent(new Event('click'));
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.setHeading(true);
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '.cart-main-items-container',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  updateCartState() {
    const config = {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
    };

    // Fetch the cart-icon-bubble section to update the cart count
    fetch(`${window.Shopify.routes.root}?section_id=cart-icon-bubble`, config)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const cartIconBubble = document.querySelector('#cart-count-bubble');
        const newCartIconBubble = html.querySelector('#cart-count-bubble');

        if (cartIconBubble && newCartIconBubble) {
          cartIconBubble.innerHTML = newCartIconBubble.innerHTML;
        } else if (newCartIconBubble) {
          document.querySelector('.is-cart').appendChild(newCartIconBubble);
        }
      })
      .catch((error) => {
        console.error('Error updating cart state:', error);
      });
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
